"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandgradingResultPage = exports.HandgradingResult = exports.HandgradingResultCoreData = void 0;
var applied_annotation_1 = require("./applied_annotation");
var comment_1 = require("./comment");
var criterion_result_1 = require("./criterion_result");
var handgrading_rubric_1 = require("./handgrading_rubric");
var http_client_1 = require("./http_client");
var utils_1 = require("./utils");
var HandgradingResultCoreData = /** @class */ (function () {
    function HandgradingResultCoreData(args) {
        this.pk = args.pk;
        this.last_modified = args.last_modified;
        this.submission = args.submission;
        this.group = args.group;
        this.finished_grading = args.finished_grading;
        this.points_adjustment = args.points_adjustment;
        this.submitted_filenames = args.submitted_filenames;
        this.total_points = args.total_points;
        this.total_points_possible = args.total_points_possible;
    }
    return HandgradingResultCoreData;
}());
exports.HandgradingResultCoreData = HandgradingResultCoreData;
var HandgradingResult = /** @class */ (function (_super) {
    __extends(HandgradingResult, _super);
    function HandgradingResult(args) {
        var _this = _super.call(this, args) || this;
        _this.handgrading_rubric = new handgrading_rubric_1.HandgradingRubric(args.handgrading_rubric);
        _this.applied_annotations = args.applied_annotations.map(function (item) { return new applied_annotation_1.AppliedAnnotation(item); });
        _this.comments = args.comments.map(function (item) { return new comment_1.Comment(item); });
        _this.criterion_results = args.criterion_results.map(function (item) { return new criterion_result_1.CriterionResult(item); });
        return _this;
    }
    HandgradingResult.subscribe = function (observer) {
        HandgradingResult._subscribers.add(observer);
    };
    HandgradingResult.unsubscribe = function (observer) {
        HandgradingResult._subscribers.delete(observer);
    };
    HandgradingResult.get_all_summaries_from_project = function (project_pk, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.page_url, page_url = _c === void 0 ? '' : _c, _d = _b.include_staff, include_staff = _d === void 0 ? true : _d, _e = _b.page_num, page_num = _e === void 0 ? 1 : _e, _f = _b.page_size, page_size = _f === void 0 ? 1000 : _f;
        return __awaiter(this, void 0, void 0, function () {
            var queries, url, response;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        queries = "?page_size=" + page_size + "&page=" + page_num + "&include_staff=" + include_staff;
                        url = page_url !== '' ? page_url :
                            "/projects/" + project_pk + "/handgrading_results/" + queries;
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().get(url)];
                    case 1:
                        response = _g.sent();
                        return [2 /*return*/, new HandgradingResultPage(response.data)];
                }
            });
        });
    };
    HandgradingResult.get_by_group_pk = function (group_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/groups/" + group_pk + "/handgrading_result/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new HandgradingResult(response.data)];
                }
            });
        });
    };
    HandgradingResult.get_or_create = function (group_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/groups/" + group_pk + "/handgrading_result/", {})];
                    case 1:
                        response = _a.sent();
                        result = new HandgradingResult(response.data);
                        // Only notify the observer if a handgrading result is actually created
                        if (response.status === 201) {
                            HandgradingResult.notify_handgrading_result_created(result);
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    HandgradingResult.notify_handgrading_result_created = function (handgrading_result) {
        var e_1, _a;
        try {
            for (var _b = __values(HandgradingResult._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_handgrading_result_created(handgrading_result);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HandgradingResult.get_file_from_handgrading_result = function (group_pk, file, on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/groups/" + group_pk + "/handgrading_result/file/?filename=" + file, { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, utils_1.blob_to_string(response.data)];
                }
            });
        });
    };
    HandgradingResult.prototype.save_finished_grading = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().patch("/groups/" + this.group + "/handgrading_result/", { finished_grading: this.finished_grading })];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, new HandgradingResult(response.data));
                        HandgradingResult.notify_handgrading_result_changed(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    HandgradingResult.prototype.save_points_adjustment = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().patch("/groups/" + this.group + "/handgrading_result/", { points_adjustment: this.points_adjustment })];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, new HandgradingResult(response.data));
                        HandgradingResult.notify_handgrading_result_changed(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    HandgradingResult.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var original_data, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        original_data = {
                            last_modified: this.last_modified,
                            total_points: this.total_points,
                            total_points_possible: this.total_points_possible,
                        };
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/groups/" + this.group + "/handgrading_result/")];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, new HandgradingResult(response.data));
                        if (original_data.last_modified !== this.last_modified
                            || original_data.total_points !== this.total_points
                            || original_data.total_points_possible !== this.total_points_possible) {
                            HandgradingResult.notify_handgrading_result_changed(this);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    HandgradingResult.notify_handgrading_result_changed = function (handgrading_result) {
        var e_2, _a;
        try {
            for (var _b = __values(HandgradingResult._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_handgrading_result_changed(handgrading_result);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    HandgradingResult.reset = function (group_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().delete("/groups/" + group_pk + "/handgrading_result/")];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/groups/" + group_pk + "/handgrading_result/", {})];
                    case 2:
                        response = _a.sent();
                        result = new HandgradingResult(response.data);
                        HandgradingResult.notify_handgrading_result_changed(result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    HandgradingResult.prototype.has_correct_submission = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/groups/" + this.group + "/handgrading_result/has_correct_submission/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    HandgradingResult._subscribers = new Set();
    HandgradingResult.EDITABLE_FIELDS = [
        'finished_grading',
        'points_adjustment',
    ];
    return HandgradingResult;
}(HandgradingResultCoreData));
exports.HandgradingResult = HandgradingResult;
var HandgradingResultPage = /** @class */ (function () {
    function HandgradingResultPage(args) {
        this.count = args.count;
        this.next = args.next;
        this.previous = args.previous;
        this.results = args.results;
    }
    return HandgradingResultPage;
}());
exports.HandgradingResultPage = HandgradingResultPage;
//# sourceMappingURL=handgrading_result.js.map